import { useMemo } from 'react';

import { mobileBreakpoint, useIsMobile, useL10n } from '@uplift/hooks';
import { Alert } from '@uplift/ui-v2';

import { useBillingContext } from '../billing.context';


export const UnpaidServicesBanner: React.VFC = () => {
  const { balance, outstandingPaymentsCount, cardExpiredOrDeclined } = useBillingContext();
  const isMobile = useIsMobile(mobileBreakpoint);
  const l10n = useL10n();

  const alert = useMemo(() => {
    if (outstandingPaymentsCount === 2) {
      return (
        <Alert flat={isMobile} severity="warning">
          {l10n.accountSettings.billing.twoUnpaidServices}
        </Alert>
      );
    }
    if (outstandingPaymentsCount >= 3) {
      return (
        <Alert flat={isMobile} severity="warning">
          {`${l10n.accountSettings.billing.threeUnpaidServices} ${l10n.accountSettings.billing.payOffYourBalance}`}
        </Alert>
      );
    }
    return null;
  }, [ outstandingPaymentsCount, l10n, isMobile ]);

  if ( cardExpiredOrDeclined || !alert || !balance) {
    return null;
  }

  return alert;
};
